export default __webpack_public_path__ + "static/media/dashboard.c405b2b1.png";